import React from 'react';

import constants from '../util/constants';

import './Header.css';

export const Header = () => {
  return (
    <nav>
      <div className="nav-wrapper">
        <a href="/">
          <img alt="logo" className="logo" src="/images/Charter_R_Logo_White.png" />
        </a>
        <span>{constants.title}</span>
      </div>
    </nav>
  );
};
